import React from "react";
import { createUseStyles } from "react-jss";
import { LazyImage } from "react-lazy-images";

const useStyles = createUseStyles((theme) => ({
	root: {
		maxWidth: "120px",
	},
	img: {
		maxHeight: "50px",
		maxWidth: "100%",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		img: {
			maxHeight: "30px",
		},
	},
}));

const ProviderLogo = ({ name, webpTransformer, path }) => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<LazyImage
				src={!!webpTransformer ? webpTransformer(path) : path}
				placeholder={({ imageProps, ref }) => <img ref={ref} className={classes.img} />}
				actual={({ imageProps }) => <img {...imageProps} className={classes.img} alt={name} />}
			/>
		</div>
	);
};

export default ProviderLogo;
